import { motion } from 'framer-motion'
import React, { useEffect, useState } from 'react'
import ParticlesBG from './Particles'
import ParticlesBelow from './ParticlesBelow'
// import Parallax from 'parallax-js'

import mars from '../assets/mars.png'

export default function Landing() {

    const [scrolled, setscrolled] = useState('0vw')
    const [scrolledR, setscrolledR] = useState('0vw')
    const [scrollOp, setscrollOp] = useState(1)

    const handleScroll = () => {
        let scroll = window.scrollY
        let vw = window.innerHeight
        if (scroll > vw / 1.5) {
            setscrolled('-100vw')
            setscrolledR('100vw')
            setscrollOp(0)
        } else {
            setscrolled('0vw')
            setscrolledR('0vw')
            setscrollOp(1)
        }
    }

    useEffect(() => {
        window.addEventListener('scroll', handleScroll)
        // var scene = document.getElementById('scene');
        // var parallaxInstance = new Parallax(scene, {
        //     calibrateY: false
        // });
        // parallaxInstance.friction(0.1, 0.1);
        // parallaxInstance.calibrate(false, false);
        // if (window.innerWidth <= 767) parallaxInstance.disable()
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
        <div className="page" id="landing">
            <ParticlesBG />
            <ParticlesBelow />
            <div className="landing-name">
                <motion.div
                    initial={{ x: '100vw', opacity: 0 }}
                    animate={{ x: scrolled, opacity: scrollOp }}
                    transition={{ ease: "easeOut", duration: .5, delay: 0 }}
                    className="line-col"
                    id="line-col1">
                </motion.div>
                <motion.div
                    initial={{ x: -100, opacity: 0 }}
                    animate={{ x: scrolled, opacity: scrollOp }}
                    transition={{ ease: "easeOut", duration: .8 }} id="landing-fname">
                    NITHIN
                    </motion.div>
                <motion.div
                    initial={{ x: -100, opacity: 0 }}
                    animate={{ x: scrolled, opacity: scrollOp }}
                    transition={{ ease: "easeOut", duration: .8, delay: .1 }}
                    id="landing-lname">
                    SAI
                    </motion.div>
                <motion.div
                    initial={{ x: '-110vw', opacity: 0 }}
                    animate={{ x: scrolled, opacity: scrollOp }}
                    transition={{ ease: "easeOut", duration: .5, delay: 0 }}
                    className="line-col"
                    id="line-col2">
                </motion.div>
            </div>
            <div className="mars-img">
                <motion.img
                    // initial={{ opacity: 0, scale: .5 }}
                    // animate={{ opacity: 1, scale: 1 }}
                    initial={{ x: '0vw', opacity: 1, scale: .7 }}
                    animate={{ x: scrolledR, opacity: scrollOp, scale: 1 }}
                    transition={{ ease: "easeInOut", duration: 1.7, delay: .2 }}
                    style={{ size: 'contain' }}
                    id="mars-image"
                    src={mars}>
                </motion.img>
            </div>
            <div id="greet">
                <motion.div
                    initial={{ x: 100, opacity: 0 }}
                    animate={{ x: scrolledR, opacity: scrollOp }}
                    transition={{ ease: "easeOut", duration: .8, delay: 0 }} className="some-info">
                    HEY THERE!
                </motion.div>
                <motion.div
                    initial={{ x: 100, opacity: 0 }}
                    animate={{ x: scrolledR, opacity: scrollOp }}
                    transition={{ ease: "easeOut", duration: .8, delay: .1 }}
                    className="some-info">
                    VISIT
                </motion.div>
                <motion.div
                    initial={{ x: 100, opacity: 0 }}
                    animate={{ x: scrolledR, opacity: scrollOp }}
                    transition={{ ease: "easeOut", duration: .8, delay: .2 }}
                    className="some-info">
                    <a href="https://github.com/ninjaasmoke" target="_blank" rel="noopener noreferrer" className="link">
                        MY GITHUB
                    </a>
                </motion.div>
                <a href="mailto:nithins674@gmail.com" target="_blank" rel="noopener noreferrer" className="link">
                    <motion.div
                        initial={{ x: 100, opacity: 0 }}
                        animate={{ x: scrolledR, opacity: scrollOp }}
                        transition={{ ease: "easeOut", duration: .8, delay: .3 }}
                        className="some-info">
                        EMAIL ME
                </motion.div>
                </a>
            </div>
            <motion.div
                initial={{ y: '100vh', opacity: 0, rotate: '-90deg', }}
                animate={{ y: '0', opacity: scrollOp, rotate: '-90deg' }}
                transition={{ ease: 'easeOut', duration: .6, delay: 1 }}
                className="scroll-down-lf"> <span className="fa fa-long-arrow-left"></span> SCROLLDOWN</motion.div>
        </div>
    )
}
